import { Injectable } from '@angular/core';

/*
  Generated class for the LocalStorageServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LocalStorageServiceProvider {

  constructor() {
  }

  public setStorage(key, value) {
    if (key && value) {
      if (value instanceof Object) {
        window.localStorage.setItem(key, JSON.stringify(value));
        return;
      }
      window.localStorage.setItem(key, value);
    }
  }

  public getStorage(key) {
    return key && window.localStorage.getItem(key);
  }

  public removeStorage(key) {
    return window.localStorage.removeItem(key);
  }

}



// WEBPACK FOOTER //
// ./src/providers/local-storage-service/local-storage-service.ts